import WebApi from "@/views/loyalty/shared/modules/web_api"

// JustPay Service for <justpay url>/api/client
// client are company, organization or owner
export class JustpayClientEndpoint {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/client/`
        this.webApi = new WebApi()
    }

    async getClients () {
        const clients = await this.webApi.post(`${this.url}list`, { id: null, page: 1, limit: -1 })
        console.log('clients:', clients.data)
        if (!clients.status_code) {
            if (!clients.error) {
                if (clients) {
                    return clients.data
                } else {
                    return null
                }
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${client.status_code}`)
        }
    }

    // get response, return response.data
    async getClientEndpoint (clientId) {
        const client = await this.webApi.post(`${this.url}get`, { id: clientId || '' })
        console.log('client:', client)
        if (!client.status_code) {
            if (!client.error) {
                if (client.data) {
                    return client.data
                } else {
                    return null
                }
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${client.status_code}`)
        }
    }
}
